<template>
  <v-list style="background-color: transparent;">
    <v-list-item style="background-color: rgba(255, 255, 255, 0.1);">
      <v-list-item-avatar>
        <v-img :src="user.picture !== '' ? user.picture : require('@/assets/user.png')" :alt="user.name" />
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title style="width: 183px;">{{ user.name.trim() !== '' ? user.name : user.email }}</v-list-item-title>
        <v-list-item-subtitle v-if="user.name.trim() !== ''" style="width: 195px;">
          {{ user.email }}
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-icon>
        <v-menu bottom left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>more_vert</v-icon>
            </v-btn>
          </template>

          <v-list dense>
            <v-list-item @click="profile = true">
              <v-list-item-icon class="mr-2">
                <v-icon>person</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                Dados Pessoais
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="logoff()">
              <v-list-item-icon class="mr-2">
                <v-icon>power_settings_new</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                Sair
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-list-item-icon>
    </v-list-item>
    <v-dialog v-model="profile" width="540px" persistent :fullscreen="$vuetify.breakpoint.xsOnly">
      <!-- Em tela cheia o cartão não rola sozinho, e o conteúdo que passa da
           altura do aparelho fica inalcançável. -->
      <v-card :style="$vuetify.breakpoint.xsOnly ? 'height: 100%; overflow-y: auto;' : ''">
        <v-card-title>
          <v-spacer />
          <v-btn icon @click="cancel()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <div class="mx-auto text-center">
          <v-avatar size="128" class="mt-0 mb-2">
            <v-img :src="user.picture !== '' ? user.picture : require('@/assets/user.png')" />
          </v-avatar>
        </div>
        <v-card-text class="text-center">
          Para definir ou alterar sua imagem de perfil, utilize o serviço <a href="https://gravatar.com" target="_blank">Gravatar</a>.<br>
          <strong>Atenção!</strong> A Embrapa e seus parceiros <u>NÃO</u> armazenam sua foto.
        </v-card-text>
        <v-alert type="error" icon="warning" :value="error" transition="scale-transition" class="mx-6 mt-0 mb-6" v-if="!remove">
          {{ message }}
        </v-alert>
        <v-card-text class="text-center">
          <v-text-field
            label="e-Mail"
            v-model="user.email"
            outlined
            append-icon="mail"
            disabled
          />

          <v-text-field
            label="Nome (opcional)"
            v-model="name"
            outlined
            append-icon="edit"
            hint="Seu nome, apelido ou como quer ser chamado."
          />

          <v-switch
            v-if="passkeyAvailable"
            v-model="passkeyEnabled"
            :loading="passkeyLoading"
            :disabled="passkeyLoading"
            inset
            color="primary"
            @change="handlePasskeyToggle"
            class="mt-0 px-1"
          >
            <template v-slot:label>
              <div>
                <strong>Login com biometria ({{ passkeyDeviceType }})</strong>
                <v-icon class="ml-2" color="primary">fingerprint</v-icon>
              </div>
            </template>
          </v-switch>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="error"
            text
            @click="remove = !remove"
            :disabled="true"
          >
            Apagar Perfil
            <v-icon color="error">
              {{ remove ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
            </v-icon>
          </v-btn>

          <v-spacer />

          <v-btn
            color="success white--text"
            depressed
            large
            @click="save()"
            :loading="loading"
          >
            Salvar
            <v-icon class="ml-1">
              done
            </v-icon>
          </v-btn>
        </v-card-actions>
        <v-expand-transition>
          <div v-show="remove">
            <v-divider />
            <v-card-text class="mb-0 pb-0 text-justify">
              <p>
                Você pode <strong>apagar completamente seu perfil de usuário</strong> a qualquer monento.
                Isto removerá todas as suas informações dos nossos servidores remotos, tal como seus dados pessoais, de fazendas e os utilizados nas simulações.
                Esteja ciente, no entanto, que esta é uma <u>ação irreversível</u>, ou seja, seus dados e histórico de acesso serão <u>permanentemente apagados</u>
                sem qualquer possibilidade de recuperação.
              </p>
            </v-card-text>
            <v-alert type="error" icon="warning" :value="error" transition="scale-transition" class="mx-2 my-0" v-if="remove">
              {{ message }}
            </v-alert>
            <v-window v-model="step">
              <v-window-item>
                <v-card-actions>
                  <v-switch
                    v-model="aware"
                    label="Estou ciente e quero continuar."
                    inset
                    class="ml-2"
                  />

                  <v-spacer />

                  <v-btn
                    color="primary white--text"
                    text
                    large
                    @click="sendRemovePin()"
                    :disabled="!aware"
                    :loading="loading"
                  >
                    Prosseguir
                    <v-icon class="ml-1">
                      arrow_forward
                    </v-icon>
                  </v-btn>
                </v-card-actions>
              </v-window-item>
              <v-window-item>
                <v-card-text class="text-justify red darken-2 white--text">
                  Um número de 6 dígitos foi enviado para o e-mail <strong>{{ user.email }}</strong>. Se tiver realmente certeza de que quer continuar, insira-o abaixo:
                </v-card-text>
                <div class="input-wrapper my-5" style="width: 280px; margin: 0 auto;">
                  <v-otp-input v-model="pin" length="6" />
                </div>
                <v-card-actions>
                  <v-btn
                    color="error"
                    text
                    @click="cancel()"
                  >
                    Cancelar
                  </v-btn>

                  <v-spacer />

                  <v-btn
                    color="warning"
                    depressed
                    :disabled="pin.length !== 6"
                    large
                    @click="removeAccount()"
                    :loading="loading"
                  >
                    Remover Conta
                    <v-icon class="ml-1">
                      done
                    </v-icon>
                  </v-btn>
                </v-card-actions>
              </v-window-item>
            </v-window>
          </div>
        </v-expand-transition>
      </v-card>
      <message-wrapper ref="message" />
    </v-dialog>
    <confirm-wrapper ref="confirm" />
  </v-list>
</template>

<script>
import axios from 'axios'
import { startRegistration } from '@simplewebauthn/browser'

import MessageWrapper from '@/components/MessageDialog.vue'
import ConfirmWrapper from '@/components/ConfirmDialog.vue'

import ErrorHelper from '@/helpers/error'
import PasskeyHelper from '@/helpers/passkey'

export default {
  mixins: [
    ErrorHelper,
    PasskeyHelper
  ],
  components: {
    MessageWrapper,
    ConfirmWrapper
  },
  data () {
    return {
      user: {
        name: '',
        email: '',
        picture: '',
        embrapa: false
      },
      name: '',
      profile: false,
      remove: false,
      aware: false,
      step: 0,
      pin: '',
      loading: false,
      error: false,
      message: '',
      headers: {},
      passkeyAvailable: false,
      passkeyEnabled: false,
      passkeyLoading: false,
      passkeyDeviceType: 'Touch ID, Face ID ou Windows Hello'
    }
  },
  mounted () {
    if (this.$localStorage.get('user').authenticated) {
      this.user = this.$localStorage.get('user')
      this.name = this.user.name

      this.headers = {
        Authorization: 'Bearer ' + this.user.token
      }
    }

    this.checkPasskeyAvailability()
  },
  watch: {
    profile (val) {
      if (val) {
        this.passkeySync()
      }
    }
  },
  methods: {
    cancel () {
      if (this.user) {
        this.name = this.user.name
      } else {
        this.name = ''
      }

      this.remove = false
      this.aware = false
      this.step = 0
      this.pin = ''
      this.loading = false

      this.profile = false
    },
    sendRemovePin () {
      this.error = false

      if (!navigator.onLine) {
        this.message = 'É necessário uma conexão com a internet para prosseguir! Por favor, verifique suas configurações de rede ou tente novamente mais tarde.'

        this.error = true

        return
      }

      const err = error => {
        this.loading = false

        this.message = this.errorMessage(error)

        this.error = true
      }

      this.loading = true

      const api = process.env.VUE_APP_API

      axios.get(api + '/status', { timeout: 12000, headers: this.headers }).then(response => {
        axios.post(api + '/user/remove/pin', { email: this.email }, { headers: this.headers }).then(response => {
          this.loading = false

          this.step++
        }).catch(err)
      }).catch(err)
    },
    removeAccount () {
      this.error = false

      if (!navigator.onLine) {
        this.message = 'É necessário uma conexão com a internet para prosseguir! Por favor, verifique suas configurações de rede ou tente novamente mais tarde.'

        this.error = true

        return
      }

      const err = error => {
        this.loading = false

        this.message = this.errorMessage(error)

        this.error = true
      }

      this.loading = true

      const api = process.env.VUE_APP_API

      axios.get(api + '/status', { timeout: 12000, headers: this.headers }).then(response => {
        axios.post(api + '/user/remove/confirm', { pin: this.pin }, { headers: this.headers }).then(response => {
          this.$refs.message.open(
            'Todos os seus dados na nuvem foram completamente apagados!',
            'success'
          )

          this.cleanup()

          this.cancel()

          window.location.reload()
        }).catch(err)
      }).catch(err)
    },
    save () {
      this.error = false

      if (!navigator.onLine) {
        this.message = 'É necessário uma conexão com a internet para prosseguir! Por favor, verifique suas configurações de rede ou tente novamente mais tarde.'

        this.error = true

        return
      }

      const err = error => {
        this.loading = false

        this.message = this.errorMessage(error)

        this.error = true
      }

      this.loading = true

      const api = process.env.VUE_APP_API

      axios.get(api + '/status', { timeout: 12000, headers: this.headers }).then(response => {
        axios.post(api + '/user/name', { name: this.name }, { headers: this.headers }).then(response => {
          this.user.name = this.name

          this.$localStorage.set('user', this.user)

          this.$emit('message', 'Seu nome foi alterado com sucesso!', 'success')

          this.loading = false

          this.profile = false
        }).catch(err)
      }).catch(err)
    },
    cleanup () {
      this.user = {
        authenticated: false,
        email: '',
        name: '',
        picture: '',
        token: '',
        embrapa: false
      }

      this.$localStorage.set('user', this.user)

      this.$localStorage.set('reliable', false)

      this.$localStorage.set('email', '')

      this.$root.$data.trySync = true
    },
    logoff () {
      this.$refs.confirm.open(
        'Sair',
        'Deseja realmente sair/deslogar do aplicativo?',
        { color: 'error' }).then((confirm) => {
        if (confirm) {
          this.cleanup()

          this.$router.push({ path: '/' })
        }
      })
    },
    async checkPasskeyAvailability () {
      try {
        if (!window.PublicKeyCredential) {
          this.passkeyAvailable = false
          return
        }

        // eslint-disable-next-line no-undef
        const available = await PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable()
        this.passkeyAvailable = available

        // Detecta tipo de dispositivo
        if (available) {
          const userAgent = navigator.userAgent
          if (userAgent.includes('Mac')) {
            this.passkeyDeviceType = 'Touch ID ou Face ID'
          } else if (userAgent.includes('Windows')) {
            this.passkeyDeviceType = 'Windows Hello'
          } else if (userAgent.includes('Android')) {
            this.passkeyDeviceType = 'biometria do dispositivo'
          } else if (userAgent.includes('iPhone') || userAgent.includes('iPad')) {
            this.passkeyDeviceType = 'Face ID ou Touch ID'
          }
        }
      } catch (err) {
        console.error('[Passkey] Erro ao verificar disponibilidade:', err)
        this.passkeyAvailable = false
      }
    },
    async passkeySync () {
      if (!this.passkeyAvailable || !navigator.onLine) return

      this.passkeyLoading = true

      const api = process.env.VUE_APP_API

      try {
        const response = await axios.get(api + '/passkey/list', { headers: this.headers })
        this.passkeyEnabled = response.data.passkeys && response.data.passkeys.length > 0
      } catch (error) {
        console.error('[Passkey] Erro ao verificar passkeys:', error)
        this.passkeyEnabled = false
      } finally {
        this.passkeyLoading = false
      }
    },
    async handlePasskeyToggle (enabled) {
      if (enabled) {
        await this.passkeyRegister()
      } else {
        await this.passkeyRemove()
      }
    },
    async passkeyRegister () {
      this.passkeyLoading = true

      try {
        const api = process.env.VUE_APP_API

        // 1. Obter options do servidor
        const optionsRes = await axios.post(
          `${api}/passkey/register-options`,
          {},
          { headers: this.headers }
        )

        // 2. Iniciar registro (navegador exibe prompt de biometria)
        const attResp = await startRegistration({ optionsJSON: optionsRes.data })

        // 3. Enviar credencial para servidor verificar
        await axios.post(
          `${api}/passkey/register-verify`,
          attResp,
          { headers: this.headers }
        )

        this.passkeyRemember(attResp.id)

        this.passkeyEnabled = true
        this.$emit('message', 'Biometria registrada com sucesso!', 'success')
      } catch (err) {
        console.error('Passkey registration error:', err)

        this.passkeyEnabled = false

        if (err.name === 'NotAllowedError') {
          this.message = 'Operação cancelada ou não autorizada pelo navegador.'
        } else if (err.name === 'NotSupportedError') {
          this.message = 'Seu navegador ou dispositivo não suporta Passkeys.'
        } else {
          this.message = this.errorMessage(err)
        }

        this.error = true
      } finally {
        this.passkeyLoading = false
      }
    },
    async passkeyRemove () {
      const confirmed = await this.$refs.confirm.open(
        'Remover Biometria',
        'Deseja realmente remover a biometria? Você precisará usar PIN para fazer login.',
        { color: 'warning', icon: 'fingerprint' }
      )

      if (!confirmed) {
        this.passkeyEnabled = true // Reverte o switch
        return
      }

      this.passkeyLoading = true

      try {
        const api = process.env.VUE_APP_API

        await axios.delete(`${api}/passkey/remove-all`, { headers: this.headers })

        this.passkeyEnabled = false
        this.$emit('message', 'Biometria removida com sucesso!', 'success')
      } catch (err) {
        console.error('Passkey remove error:', err)

        this.passkeyEnabled = true // Reverte o switch

        this.message = this.errorMessage(err)
        this.error = true
      } finally {
        this.passkeyLoading = false
      }
    }
  }
}
</script>
